export default __webpack_public_path__ + "static/media/VolvoNovum-Bold.b9800837.eot";